// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root___GBNE","inner":"Form_inner__HRqmk","range":"Form_range__3CWTS","name":"Form_name__HuliI","actions":"Form_actions__1BO6B"};